import { AotherTemp, AutoBillingDetail, AutoInvoiceDetailList } from "./AutoBillingDetail";
import { TrackableEntity } from "./data/ChangeTrackable";

export class AutoBillingHD {

    search: string = '';
    invoiceRemarks: string = '';
    invoiceDate: string | null = null;
    invoiceNo: string = '';
    group:string ='';


    billingDetailList: AutoBillingDetail[] = [];
    invoiceDetailList: AutoInvoiceDetailList[] = [];
    aotherTempList: AotherTemp[] = [];
}

